import { useTranslation } from '../../../i18n/i18n';
import { ColumnsType } from 'antd/es/table';
import { Table, Typography } from 'antd';
import React from 'react';
import EmptyState from '../../utils/EmptyState/EmptyState';

const { Text } = Typography;
interface HistoryTableItem {
  uuid: string;
  location: string;
  idLocation: string;
  inDate: string;
  outDate: string;
  duration: string;
}

interface HistoryTableProps {
  items: HistoryTableItem[];
  actionNode?: React.ReactNode;
}
const HistoryTable = ({ items, actionNode }: HistoryTableProps) => {
  const { t } = useTranslation('devices', { keyPrefix: 'history' });

  const columns: ColumnsType<HistoryTableItem> = [
    {
      title: t('location'),
      dataIndex: 'location',
      key: 'location',
      width: '20%',
      render: (text: string) => <Text className={'MainTableText'}>{text}</Text>,
    },
    {
      title: t('idLocation'),
      dataIndex: 'idLocation',
      key: 'idLocation',
      width: '35%',
    },
    {
      title: t('entrance'),
      dataIndex: 'inDate',
      key: 'inDate',
      width: '15%',
    },
    {
      title: t('exit'),
      dataIndex: 'outDate',
      key: 'outDate',
      width: '15%',
    },
    {
      title: t('duration'),
      dataIndex: 'duration',
      key: 'duration',
      width: '15%',
    },
  ];
  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={items}
      rowKey={(record) => record.uuid}
      pagination={false}
      locale={{
        emptyText: (
          <EmptyState
            title={t('emptyTitle')}
            description={t('emptyDescription')}
            action={actionNode}
          />
        ),
      }}
    />
  );
};

export default HistoryTable;
